import React from 'react'
import './stylesheets/servicestopbar.css'
import { NavLink } from 'react-router-dom'

function Servicestopbar() {
    return (
        <div>
            <div className='stb'>
                <p><NavLink className="links" to="/art">art</NavLink></p>
                <p><NavLink className="links" to="/business">business</NavLink></p>
                <p><NavLink className="links" to="/coaching">coaching</NavLink></p>
                <p><NavLink className="links" to="/design">design</NavLink></p>
                <p><NavLink className="links" to="/ecommerce">ecommerce</NavLink></p>
                <p><NavLink className="links" to="/finance">finance</NavLink></p>
                <p><NavLink className="links" to="/gamedev">gamedev</NavLink></p>
                <p><NavLink className="links" to="/html">html</NavLink></p>
                <p><NavLink className="links" to="/ios">ios</NavLink></p>
                <p><NavLink className="links" to="/javascript">javascript</NavLink></p>
            </div>
        </div>
    )
}

export default Servicestopbar
